import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const SidebarStyle = {
  index: (openSidebar: boolean) => css`
    position: fixed;
    top: 0;
    left: 0;
    width: 180px;
    height: 100%;
    background-color: #fff;
    z-index: 99;
    transform: translateX(${!openSidebar ? "-180px" : 0});
    transition: all 0.25s ease-in-out;
  `,
  overlay: css`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 98;
    background-color: rgb(0 0 0 / 0.5);
  `,
  content: css``,
  header: css`
    height: calc(112px);
    color: rgb(255 255 255 / 1);
    background-color: ${theme.colors.orange[200]};
    justify-content: center;
    align-items: center;
    flex-direction: column;
    display: flex;
    position: relative;

    button {
      display: block;
      height: 1.25rem;
      margin: 4px auto;
      padding: 0 0.5rem;
      color: rgb(255 255 0 / 1);
      border-width: 1px;
      border-style: solid;
      border-color: rgb(255 255 0 / 1);
      border-radius: 5px;
      background-color: transparent;
      min-width: 100px;
    }

    .date {
      font-size: 14px;
      font-weight: 400;
      margin-top: 4px;
    }
  `,
  close: css`
    color: ${theme.colors.orange[200]};
    background-color: rgb(255 255 255 / 1);
    font-size: 1.125rem;
    line-height: 1.75rem;
    border-radius: 9999px;
    justify-content: center;
    align-items: center;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  `,
  menus: css``,

  itemMenu: css`
    color: black;
    border-bottom: 1px solid ${theme.colors.orange[200]};
    font-size: 0.875rem;
    line-height: 1.25rem;
    align-items: center;
    height: 2.5rem;
    display: flex;
    cursor: pointer;

    svg {
      height: 20px;
      text-align: center;
      justify-content: center;
      align-items: center;
      display: inline-flex;
      width: 2.25rem;

      path {
        fill: ${theme.colors.orange[200]};
      }
    }

    span {
      align-items: center;
      margin-left: 4px;
    }
  `,
  info: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    .username {
      font-size: 14px;
      font-weight: 500;
      margin: 0 0 12px;
      text-align: center;
    }
  `,
  logout: css`
    padding: 12px 4px;

    button {
      width: 100%;
      color: white;
      border-color: transparent;
      border-radius: 8px;
      background-color: #4c9bb6;
    }
  `,
};
